// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"91ef1b65","554":"84840085","782":"31cbd8db","812":"7914dd6d","960":"e9108423","989":"eada59f7"}[chunkId] + ".chunk.js";
};